<template>
<!-- te-popup begin -->
<div class="te-alert d-flex flex-column">
  <a href="javascript:void(0)" aria-label="Close" class="close" style="z-index: 10;" @click="close">
    <i class="material-icons">close</i>
  </a>
   <PerfectScrollbar>
  <div class="content d-flex align-items-center flex-column flex-grow-1">
    <slot />
  </div>
   </PerfectScrollbar>
  <!-- <div class="alert-btn">
    <button class="mx-1 btn btn-sm btn-light rounded-pill" @click="close">
      <span class="px-3">取消</span>
    </button>
    <button class="mx-1 btn btn-sm btn-primary rounded-pill">
      <span class="px-3">確定</span>
    </button>
  </div> -->
</div>
<!-- te-popup end -->
</template>
<script>
import PerfectScrollbar from '@/components/PerfectScrollbar.vue';

export default {
  components: {
    PerfectScrollbar,

  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('update:isOpen', false);
    },
  },
};
</script>
